import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {ExcRestService, IExcDataDistinct, IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {ExgApplicationTabService} from 'exc-tab-v2';
import {ExgDataTableComponent, ExgModalService, ExgTableSettingsComponent} from 'exc-controls-v2';
import {ExgTabV2Component, ExgTabV2ComponentHeaderElement} from '../misc/exg-tab-v2/exg-tab-v2.component';
import {ExgFilterComponent} from '../misc/exg-filter/exg-filter.component';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';
import {ReceiptDetailsComponent} from './drawer/receipt-details.component';
import {EnumerationService} from '../services/enumeration.service';
import {ExcSecurityService} from 'exc-security-v2';
import {ApplicationService} from '../services/application.service';
import {ExgFilterChipsComponent} from '../misc/exg-filter-chips/exg-filter-chips.component';
import {BehaviorSubject} from 'rxjs';
import {ExgApplicationEventEmitter} from '../misc/classes/ExgApplicationEventEmitter';
import {ExgEventArgs} from '../misc/classes/ExgEventArgs';

@Component({
  selector: 'app-receiptlist',
  templateUrl: './receipt-list.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
})
export class ReceiptListComponent extends ExcTranslation implements OnInit, AfterViewInit {
  /****************************/
  @ViewChild('VCrightTabControl', {read: ExgTabV2Component}) VCrightTabControl!: ExgTabV2Component;
  @ViewChild('VCreceipt', {read: ReceiptDetailsComponent}) VCreceipt!: ReceiptDetailsComponent;
  @ViewChild('VCreceiptTable', {read: ExgDataTableComponent}) VCreceiptTable!: ExgDataTableComponent;
  @ViewChild('VCreceiptTableFilterControl', {read: ExgFilterComponent}) VCreceiptTableFilterControl!: ExgFilterComponent;
  @ViewChild('VCreceiptTableSortControl', {read: ExgFilterComponent}) VCreceiptTableSortControl!: ExgFilterComponent;
  @ViewChild('VCreceiptTableSearchControl', {read: ExgFilterComponent}) VCreceiptTableSearchControl!: ExgFilterComponent;
  @ViewChild(ExgFilterChipsComponent) VCFilterChips!: ExgFilterChipsComponent;
  @ViewChild(ExgTableSettingsComponent) VCtableDefinitionSettings!: ExgTableSettingsComponent;
  /****************************/
  rightDrawerVisible = false;
  init = true;

  receiptTable = {
    selectKey: 'rcptID',
    state: 1,
    prefilter_type: 100,
    newV2Table: false,
    selectedRow: [] as any[],
    selectedRows: [] as any[],
    multiSelection: false,
    prefilter_DEL: 0,
    searchValue: '',
    uiFilterEnumGroup: [
      {enmName: 'ReceiptStatus', enmField: 'rcpt_enmIdent_ReceiptStatus', enmTable: 'Receipt'},
      {enmName: 'ReceiptTyp', enmField: 'rcpt_enmIdent_ReceiptType', enmTable: 'Receipt'},
      {enmName: 'Schadenart', enmField: 'aue_enmIdent_SchadenArt', enmTable: 'AuftragE_EIS', enmAlt: false,
        enmAltTT: true},
      {enmName: 'VorgangStatus', enmField: 'vorg_enmIdent_VorgangStatus', enmTable: 'Vorgang'},
      {enmName: 'VorgangTyp', enmField: 'vorg_enmIdent_VorgangTyp', enmTable: 'Vorgang'},
      {enmName: 'AuftragTyp', enmField: 'au_enmIdent_AuftragTyp', enmTable: 'Auftrag'}
    ],
    uiFilterSearchFields: [
      {tableField: 'auNr', table: 'Auftrag'},
      {tableField: 'vorgNr', table: 'Vorgang'},
      {tableField: 'Bearbeiter', table: 'Vorgang'},
      {tableField: 'vorgLCU', table: 'All', groupCaption: 'Vorgang'},
      {tableField: 'vorgLCD', table: 'All', groupCaption: 'Vorgang'},
      {groupCaption: 'Vorgang', table: 'All', tableField: 'vorgCKD'},
      {table: 'Vorgang', tableField: 'vorgFrist'},
      {tableField: 'aueSchadenNr', table: 'AuftragE_EIS', groupCaption: 'Schaden'},
      {tableField: 'aueVersicherungsnehmer', table: 'AuftragE_EIS', groupCaption: 'Schaden'},
      {tableField: 'aueSchadenOrt', table: 'AuftragE_EIS', groupCaption: 'Schaden'},
      {tableField: 'auAuftraggeberShort', table: 'Auftrag', repColumn: 'au_oeID_Auftraggeber'},
      {tableField: 'auAnsprechpartner', table: 'Auftrag'},
    ],
    uiSortFieldGroup: [
      {fieldGroup: 'Beleg', fieldTable: 'All', fieldName: 'rcptLCD'},
      {fieldGroup: 'Beleg', fieldTable: 'All', fieldName: 'rcptCRD'},
      {fieldGroup: 'Beleg', fieldTable: 'Receipt', fieldName: 'rcptReviewDate'},
      {fieldGroup: 'Beleg', fieldTable: 'Receipt', fieldName: 'rcptQSDate'},
      {fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgLCD'},
      {fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgCRD'},
      {fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgCKD'},
      {fieldGroup: 'Vorgang', fieldTable: 'Vorgang', fieldName: 'vorgFrist'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueSchadenDatum'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueAuftragsdatum'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtsterminPlan'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtstermin'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtstermin2'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueSchadenmeldungVU'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueFristverlaengerungBis'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueZwischenberichtDatum'},
    ],
    uiFilter: [] as any [],
    uiSort: [] as any [],
    uiSortAktiv(): any[] {
      return this.uiSort.filter((sort: any) => sort.uiValue !== 0);
    },
    uiFilterAktiv(filterType?: number): any[] {
      return this.uiFilter
        .filter((filters: any) => filters.applied)
        .filter((filters: any) => !filterType || (filterType && filterType === filters.filterType));
    },
    data: [] as any [],
    tableDefinition: [] as any[],
    distinctData: [] as any[],
    MetaInfo: {
      dataPaging: {pageNo: 0, pageSize: 24} as IExcDataPaging,
      dataSort: {} as IExcDataSort,
      dataFilter: {} as IExcDataFilter,
      dataDistinct: {} as IExcDataFilter,
    } as IExcMetaInfo,
    paging: {pagingPage: 0, pagingEndRow: 0, pagingPageSize: 25, pagingTotalPages: 0, pagingTotalRows: 0, pagingStartRow: 0},
    isLoading: true,
    columns: [] as any [],
    selectionChanged: (index: number) => {
      if (!this.receiptTable.multiSelection) {
        this.receiptTable.selectedRow = [];
        ExcCoreModule.Array.Add(this.receiptTable.selectedRow, this.receiptTable.data[index]);
        this.preloadDetailsData();
      }
    },
    pageChanged(page: number): void  {
      if (this.MetaInfo.dataPaging !== undefined) {
        this.MetaInfo.dataPaging.pageNo = page;
      }
      this.loadData();
    },
    search(value: string): void {
      this.searchValue = value;
      this.loadData();
    },
    ready: () => {
      if (this.receiptTable.data.length === 0) {
        this.receiptTable.state = 2;
        if (this.VCreceiptTable) {
          this.VCreceiptTable.selectedRow = -1;
        }
      } else {
        this.receiptTable.state = 0;
        if (this.VCreceiptTable) {
          this.VCreceiptTable.selectedRow = 0;
        }
      }
      this.tableIsLoading.next(false);
    },
    toggleMultiSelection: (): void => {
      if (!this.receiptTable.newV2Table) {
        if (!this.receiptTable.multiSelection) {
          this.receiptTable.selectedRow = [];
          this.receiptTable.selectedRows = [];
          this.receiptTable.multiSelection = true;
        } else if (this.receiptTable.multiSelection) {
          this.receiptTable.selectedRow = [];
          this.receiptTable.selectedRows = [];
          this.receiptTable.multiSelection = false;
          this.receiptTable.loadData();
        }
        this.rightDrawerVisible = false;
        this.tableDrawerIsLoading.next(false);
      }
    },
    loadDataObject: (incomingData: any, incomingPaging: any): void => {
      this.receiptTable.data = incomingData;
      this.receiptTable.paging = incomingPaging;
      if (incomingData.length > 0) {
        this.receiptTable.columns = Object.getOwnPropertyNames(this.receiptTable.data[0]);
      }
      this.receiptTable.isLoading = false;
      this.tableIsLoading.next(this.receiptTable.isLoading);
    },
    loadData: () => {
      const SELF = this;
      SELF.receiptTable.state = 1;
      SELF.receiptTable.isLoading = true;
      this.tableIsLoading.next(SELF.receiptTable.isLoading);

      SELF.excRestService
        .get(
          SELF.excRestService.computeUrl('ReceiptR_List', {
            fts: this.receiptTable?.searchValue
            , prefilterType: this.receiptTable.prefilter_type
            , prefilterDEL: this.receiptTable.prefilter_DEL
            , rcptStatement: false
          }), {
            MetaInfo: {
              dataPaging: this.receiptTable.MetaInfo.dataPaging,
              dataSort: this.receiptTable.MetaInfo.dataSort,
              dataFilter: this.receiptTable.MetaInfo.dataFilter
            }
          })
        .subscribe(
          (data: any) => {
            if (data.success) {
              SELF.receiptTable.loadDataObject(data.data.Receipts, data.paging.Receipts);
            }
            SELF.receiptTable.ready();
            if (SELF.init) {
              SELF.init = false;
            }
            this.VCFilterChips?.workspace.computeMetaInfo(this.appSvc.helperObj.clone(this.receiptTable.MetaInfo));
          }
        );
    },
    getDistinctData: (dataDistinct: IExcDataDistinct) => {
      this.receiptTable.MetaInfo.dataDistinct = dataDistinct;
      this.excRestService
        .sget(
          this.excRestService.computeUrl('ReceiptR_List', {
            fts: this.receiptTable?.searchValue
            , prefilterType: this.receiptTable.prefilter_type
            , prefilterDEL: this.receiptTable.prefilter_DEL
          }),
          ExcCoreModule.Guid.NewGuid(),
          {MetaInfo: this.receiptTable.MetaInfo}
        ).subscribe((ret: any) => {
        // console.log(ret.data);
        this.receiptTable.distinctData = ret.data;
      });
    },
    itemSelect: ($event: number): void => {
      this.receiptTable.selectedRows = [];
      for (const selected of this.receiptTable.selectedRow) {
        this.receiptTable.selectedRows.push(
          ExcCoreModule.Array.GetObject(
            this.receiptTable.data,
            this.receiptTable.selectKey,
            selected)
        );
      }
      this.tableDrawerIsLoading.next(false);
    }
  };
  taskDetails = {
    data: {} as any,
    loadData: (incomingData: any) => {
      this.taskDetails.data = incomingData;
    }
  };
  receiptTableDrawer = {
    data: {} as any,
    details: {} as any,
    company: {} as any,
    reference: [] as any,
    isLoading: true,

    loadData: (incomingData: any, incomingDetails?: any, incomingCompany?: any, reference?: any) => {
      this.receiptTableDrawer.data = incomingData;
      this.receiptTableDrawer.details = incomingDetails;
      this.Details = incomingDetails;
      this.receiptTableDrawer.company = incomingCompany;

      this.receiptTableDrawer.isLoading = false;
      this.tableDrawerIsLoading.next(this.receiptTableDrawer.isLoading);
    }
  };

  set Details(value: any) {
    this.details.loadDetails(
      value.caseDetails, value.taskDetails, value.caseLocation, value.caseOEs
    );
  }

  details = {
    taskDetails: {} as any,
    caseDetails: {} as any,
    caseLocation: {} as any,
    caseOEs: [] as any[],
    loadDetails: (caseDate: any, taskDate: any, locationData: any, oeData: any) => {
      this.details.loadCaseDetails(caseDate);
      this.details.loadTaskDetails(taskDate);
      this.details.loadCaseOEs(oeData);
      this.details.loadCaseLocation(locationData);
    },
    loadCaseDetails: (caseData: any) => {
      this.details.caseDetails = caseData;
    },
    loadTaskDetails: (taskData: any) => {
      this.details.taskDetails = taskData;
    },
    loadCaseLocation: (SO: any) => {
      if (SO) {
        this.details.caseLocation = SO;
      } else {
        this.details.caseLocation = {};
      }
    },
    loadCaseOEs: (OEs: any) => {
      if (OEs) {
        this.details.caseOEs = OEs;
      } else {
        this.details.caseOEs = [];
      }
    }
  };
  rightTabs: ExgTabV2ComponentHeaderElement[] = [];

  tableIsLoading = new BehaviorSubject(this.receiptTable.isLoading);
  tableDrawerIsLoading = new BehaviorSubject(this.receiptTableDrawer.isLoading);

  Events = new ExgApplicationEventEmitter();


  constructor(
    private chDecRef: ChangeDetectorRef,
    public excSecurity: ExcSecurityService,
    private excRestService: ExcRestService,
    public enumSvc: EnumerationService,
    private modalService: ExgModalService,
    private exgApplicationTabService: ExgApplicationTabService,
    public appSvc: ApplicationService) {
    super();
    setInterval(() => {
      this.chDecRef.detectChanges();
    }, 15);
  }

  /* Lifecycle Hooks */
  layoutEditorVisible = false;

  ngAfterViewInit(): void {
    this.VCreceiptTableFilterControl.ApplyFilter();
  }

  ngOnInit(): void {
    const SELF = this;
    SELF.registerEvents();
    SELF.initEnumerations();
    SELF.initialize();
    SELF.initTableDefinition();
  }

  initEnumerations(): void {
    this.receiptTable.uiFilter =
      this.appSvc.metaInfo.dataFilter(
        this.receiptTable.uiFilterEnumGroup
        , this.receiptTable.uiFilterSearchFields);
    this.receiptTable.uiSort =
      this.appSvc.metaInfo.dataSort(this.receiptTable.uiSortFieldGroup);
  }

  initTableDefinition(): void {
    this.receiptTable.tableDefinition = [
      {
        caption: this.enumSvc.getFieldCaption('Receipt', 'rcptOrderNumber')
        , value: 'rcptOrderNumber'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('Receipt', 'rcpt_enmIdent_ReceiptStatus')
        , value: 'rcpt_enmIdent_ReceiptStatus'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return this.enumSvc.getEnumerationText('ReceiptStatus', value);
        }
      },
      {
        caption: this.enumSvc.getFieldCaption('Company', 'compName')
        , value: 'compName'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('Receipt', 'rcpt_enmIdent_ReceiptType')
        , value: 'rcpt_enmIdent_ReceiptType'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return this.enumSvc.getEnumerationText('ReceiptType', value);
        }
      },
      {
        caption: this.enumSvc.getFieldCaption('Auftrag', 'auNr')
        , value: 'auNr'
        , fixed: true, align: 0, sort: 0, ordinal: 0, visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aueSchadenNr')
        , value: 'aueSchadenNr'
        , fixed: true, align: 0, sort: 0, ordinal: 0, visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('Vorgang', 'vorgNr')
        , value: 'vorgNr'
        , fixed: true, align: 0, sort: 0, ordinal: 0, visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('Vorgang', 'vorg_enmIdent_VorgangTyp')
        , value: 'vorg_enmIdent_VorgangTyp'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return this.enumSvc.getEnumerationText('VorgangTyp', value);
        }
      },
      {
        caption: this.enumSvc.getFieldCaption('Auftrag', 'aueVersicherungsnehmer')
        , value: 'aueVersicherungsnehmer'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aueSchadenOrt')
        , value: 'aueSchadenOrt'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('Auftrag', 'au_oeID_Auftraggeber')
        , value: 'auAuftraggeber'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aue_enmIdent_SchadenArt')
        , value: 'aue_enmIdent_SchadenArt'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return this.enumSvc.getEnumerationText('Schadenart', value);
        }
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aue_enmIdent_Versicherungsart')
        , value: 'aue_enmIdent_Versicherungsart'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return this.enumSvc.getEnumerationText('Versicherungsart', value);
        }
      },
      {
        caption: this.enumSvc.getFieldCaption('All', '%CRU')
        , value: 'rcptCRU'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('All', '%CRD')
        , value: 'rcptCRD'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date', dateFormat: this.getGlobal('DateTimeFormatShort')
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('All', '%LCU')
        , value: 'rcptLCU'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('All', '%LCD')
        , value: 'rcptLCD'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date', dateFormat: this.getGlobal('DateTimeFormatShort')
        , visible: true
      },
    ];
  }

  registerEvents(): void {
    ExcCoreModule.Services().StrgI.subscribe(() => {
      if (this.exgApplicationTabService.StateTab?.Active) {
        this.rightDrawerVisible = !this.rightDrawerVisible;
      }
    });
    ExcCoreModule.Services().GlobalRefresh.subscribe(() => {
      if (!this.rightDrawerVisible) {
        this.receiptTable.loadData();
      } else {
        this.preloadDetailsData();

      }
      // this.chDecRef.markForCheck();
    });
    this.enumSvc.repositoryLoaded.subscribe(() => {
      this.initEnumerations();
      this.initTableDefinition();
    });
    this.tableDrawerIsLoading.subscribe(async (value) => {
      await this.chDecRef.reattach();
      if (!value) {
        await new Promise(f => setTimeout(f, 2000));
        this.chDecRef.detach();
      }
    });
    this.tableIsLoading.subscribe(async (value) => {
      await this.chDecRef.reattach();
      if (!value) {
        await new Promise(f => setTimeout(f, 2000));
        this.chDecRef.detach();
      }
    });
    this.Events.Receipt?.List?.Reload?.subscribe((evt: ExgEventArgs) => {
      this.tableIsLoading.next(true);
      this.receiptTable.loadData();
    });
  }


  initialize(): void {
    const SELF = this;
    SELF.rightTabs = [
      {
        get caption(): string {
          return SELF.getGlobal('Details');
        },
        icon_class: SELF.getRessource('DetailsIcon')
      },
    ];
  }


  preloadDetailsData(): void {
    const SELF = this;

    SELF.receiptTableDrawer.isLoading = true;
    this.tableDrawerIsLoading.next(SELF.receiptTableDrawer.isLoading);

    if (SELF.receiptTable.selectedRow[0]) {
      this.excRestService.get(this.excRestService
        .computeUrl('ReceiptR_Checkview', {
          rcptID: SELF.receiptTable.selectedRow[0][SELF.receiptTable.selectKey]
        }))
        .subscribe(
          (response: any) => {
            if (response.success && response.data) {
              const RESPONSE = response.data;
              /****************/
              SELF.receiptTableDrawer.loadData(
                RESPONSE.Receipt,
                {
                  caseDetails: RESPONSE.Auftrag,
                  taskDetails: RESPONSE.Vorgang,
                  caseOEs: RESPONSE.OEs,
                  caseLocation: RESPONSE.Location
                },
                RESPONSE.Company,
                RESPONSE.Reference);
              /****************/
            }
            SELF.receiptTableDrawer.isLoading = false;
            this.tableDrawerIsLoading.next(SELF.receiptTableDrawer.isLoading);
          });
    } else {
      SELF.receiptTableDrawer.loadData(
        {},
        {},
        {},
        {});
      SELF.receiptTableDrawer.isLoading = false;
      this.tableDrawerIsLoading.next(SELF.receiptTableDrawer.isLoading);
    }
  }

  reloadOpenerView: () => void = (): void => {
    this.receiptTable.loadData();
  }

  openCheckView(rcptID?: string): void {
    if (this.receiptTable.selectedRow[0]
      && !this.receiptTable.multiSelection) {
      if (!rcptID) {
        rcptID = this.receiptTable.selectedRow[0][this.receiptTable.selectKey];
        this.appSvc.Receipt.Checkview.OpenTab(rcptID, { Events: undefined, reloadOpenerView: this.reloadOpenerView });
      } else {
        this.modalService
          .showToast(this.getRessource('NoReceiptFound')
            , 'md-toast bg-red'
            , this.getRessource('ReceiptIcon'));
      }
    }
  }

  openCheckViewCollection(): void {
    if (
      this.receiptTable.selectedRow[0]
      || (this.receiptTable.multiSelection && this.receiptTable.selectedRows.length > 0)
      ) {
      const rcptID = this.receiptTable.selectedRow[0][this.receiptTable.selectKey];
      this.appSvc.Receipt.Checkview.OpenCollectionTab(
        {rcptID, selectedRows: this.receiptTable.selectedRows}
      );
    } else {
      this.modalService
        .showToast(this.getRessource('NoReceiptFound')
          , 'md-toast bg-red'
          , this.getRessource('ReceiptCollectionIcon'));
    }
  }

  change($event: { index: number; value: any }): void  {
    const enmList = $event.value.enmName;
    if (enmList === 'ReceiptType') {
      this.receiptTable.prefilter_type = $event.index;
    } else if (enmList === 'ReceiptFilterDEL') {
      this.receiptTable.prefilter_DEL = $event.index;
    }
    this.receiptTable.loadData();
  }

  rightTabs_tabChange($event: number): void {
    switch ($event) {
      case 1:
        break;
      default:
        break;
    }
  }

  toggleRightDrawer(): void {
    if (!this.receiptTable.multiSelection) {
      this.tableDrawerIsLoading.next(false);
      this.rightDrawerVisible = !this.rightDrawerVisible;

      if (this.rightDrawerVisible && this.receiptTable.selectedRow[0] && !this.receiptTable.multiSelection) {
        this.preloadDetailsData();
      }
    }
  }

  async openWorkspace(index?: number): Promise<void> {
    if (
      this.receiptTable.selectedRow[0]
      && !this.receiptTable.multiSelection
    ) {
      let rcptRow = this.receiptTable.selectedRow[0][this.receiptTable.selectKey];
      if (index) {
        rcptRow = this.receiptTable.data[index][this.receiptTable.selectKey];
        // For DblClick
        await new Promise(f => setTimeout(f, 150));
      }
      if (rcptRow) {
        this.appSvc.Receipt.Checkview
          .OpenTab(rcptRow
            , { Events: this.Events, reloadOpenerView: this.reloadOpenerView }
          );
      } else {
        this.modalService
          .showToast(this.getRessource('NoReceiptFound')
            , 'md-toast bg-red'
            , this.getRessource('ReceiptIcon'));
      }
    }
  }

  getRowAmount(row: any): number {
    if (row.rcptVATRate > 0 && row.rcptNetSum === row.rcptGrossSum ) {
      return Number(row.rcptNetSum) + (Number(row.rcptNetSum) * (Number(row.rcptVATRate) / 100));
    } else {
      return Number(row.rcptVATRate) !== 0 ? Number(row.rcptGrossSum) : Number(row.rcptNetSum);
    }
  }

  getObjectString(receiptData: any, even = true): string {
    let rtValue = '';
    if (receiptData.rcptObject && receiptData.rcptObject.length > 0) {
      const rcptObjects = JSON.parse(receiptData.rcptObject);
      for (const objElement of rcptObjects) {
        if (even && rcptObjects.indexOf(objElement) % 2 === 0) {
          rtValue += objElement.enmText + '; ';
        }
        if (!even && rcptObjects.indexOf(objElement) % 2 !== 0) {
          rtValue += objElement.enmText + '; ';
        }
      }
    }

    return rtValue;
  }

  openTaskWorkspace(): void {
    if (this.receiptTable.selectedRow
      && this.receiptTable.selectedRow[0]?.rcpt_vorgID
      && !this.receiptTable.multiSelection) {
      this.appSvc.Task.Workspace.OpenTabV2(
        this.receiptTable.selectedRow[0]?.rcpt_vorgID
      );
    }
  }

  openTableSettings($event: any): void {
    if (this.receiptTable.newV2Table) {
      this.VCtableDefinitionSettings.openFilterConfig($event);
    }
  }

  switchToStatementModule(): void {
    if (
      this.receiptTable.selectedRow[0]
      && !(
        this.appSvc.isTableLoading(this.receiptTable)
        || this.appSvc.isTableLoading(this.receiptTableDrawer)
        || this.appSvc.isTableEmpty(this.receiptTable)
        || this.receiptTable.multiSelection
      )
      && this.excSecurity.isFeatured('STATEMENTCREATE')
      && this.excSecurity.isFeatured('RECEIPTSWITCH')
      && this.receiptTableDrawer.data
    ) {
      this.modalService.showSimple(
        this.getRessource('switchToStatementTitle'),
        this.getRessource('switchToStatementMessage'),
        true,
        true,
        this.getRessource('switch'),
        this.getGlobal('Cancel')
      ).subscribe((retVal: any) => {
        if (
          this.receiptTableDrawer.data.rcptID
          && this.receiptTableDrawer.data.rcptUPT
          && retVal
        ) {
          this.excRestService
            .put(this.excRestService.computeUrl(
              'ReceiptU_switchModule', {
                rcptID: this.receiptTableDrawer.data.rcptID
              }), {
              rcptUPT: this.receiptTableDrawer.data.rcptUPT
            }).subscribe((rtVal: any) => {
            if (rtVal && rtVal.success) {
              this.receiptTable.loadData();

              this.modalService.showToast(
                this.getRessource('movedToStatement'), 'md-toast bg-green', 'fas fal fa-file-lines'
              );

              this.appSvc.Receipt.StatementCheckview
                .OpenTab(this.receiptTableDrawer.data.rcptID
                  , { Events: this.Events, reloadOpenerView: () => {} }
                );
            }
          });
        }
      });
    }
  }
}
